module.exports = __webpack_public_path__ + "img/inscripcion.cbf4093f.png";